const upload = {
  pageTitle: "Dokumente hochladen",
  intro: "Laden Sie hier Ihre Dokumente und Fotos für Ihre Schuldenberatung hoch.",
  selectButton: "Dateien auswählen",
  dropHint: "Dateien hierher ziehen oder",
  allowedFormats: "Erlaubte Formate: {{formats}}",
  maxFileSize: "Maximale Dateigröße: {{size}} pro Datei",
  checkingLink: "Link wird geprüft …",
  invalidLinkTitle: "Link ungültig",
  invalidLinkBody:
    "Dieser Upload-Link ist nicht mehr gültig. Bitte wenden Sie sich an Ihre Beratungsstelle, wenn Sie noch Dokumente übermitteln möchten.",
  successBody: "Ihre Datei(en) wurden erfolgreich übermittelt.",
  statusUploading: "Wird hochgeladen …",
  manage: {
    listTitle: "Ihre hochgeladenen Dokumente",
    loadError: "Ihre hochgeladenen Dokumente konnten nicht geladen werden. Bitte laden Sie die Seite neu.",
    preview: "Vorschau",
    thumbnailLoading: "Vorschaubild wird geladen …",
    previewNotReady: "Vorschau wird noch erstellt. Bitte versuchen Sie es später erneut.",
    previewFailed: "Vorschau konnte nicht erstellt werden.",
    delete: "Löschen",
    deleteConfirmTitle: "Dokument löschen",
    deleteConfirmText: 'Möchten Sie „{{fileName}}" wirklich löschen?',
    deleteError: "Das Dokument konnte nicht gelöscht werden. Bitte versuchen Sie es erneut.",
    deleteSuccess: "Das Dokument wurde gelöscht.",
    previewError: "Die Vorschau konnte nicht angezeigt werden. Bitte versuchen Sie es erneut.",
    alreadyProcessed:
      "Dieses Dokument wurde bereits von Ihrer Beratungsstelle übernommen und kann nicht mehr bearbeitet werden.",
  },
  errors: {
    invalidType: "Dieser Dateityp wird nicht unterstützt. Erlaubte Formate: {{formats}}.",
    tooLarge: "Die Datei ist zu groß. Maximale Dateigröße: {{size}} pro Datei.",
    maxDocuments:
      "Es wurde bereits die maximale Anzahl an Dokumenten hochgeladen. Bitte wenden Sie sich an Ihre Schuldenberatung.",
    storageLimit: "Das Speicherlimit für Uploads ist erreicht. Bitte wenden Sie sich an Ihre Schuldenberatung.",
    linkInvalid: "Der Upload-Link ist nicht mehr gültig. Bitte wenden Sie sich an Ihre Schuldenberatung.",
    generic: "Beim Hochladen ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
  },
};

export default upload;
